import useSWR from "swr";

import { type WorkflowTemplateListItem } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/workflow-templates";

interface Params {
  canManagePlatform?: boolean;
}

export function useWorkflowTemplates({
  canManagePlatform = true,
}: Params = {}) {
  return useSWR<WorkflowTemplateListItem[], Error>(
    canManagePlatform ? url : null,
    simpleFetcher,
  );
}
